/**
* Empty validation
*/

const orderName = () => {
  const inputFields = document.querySelectorAll(".is-required");
  const submitBtn = document.querySelector('.js-order-submit-btn')
  const emptyMsg = "必須項目は必ずご入力ください。";

  if (!submitBtn) return;
  submitBtn.addEventListener("click", (e) => {
    inputFields.forEach(inputField => {
      const input:any = inputField.querySelector('input[type="text"]');
      const error = inputField.querySelector('.form__error');
      if (!input || !error) return;
      if(input.value == "") {
        error.classList.add("show");
        error.innerHTML = emptyMsg
      }
    })
  })
  
  inputFields.forEach(inputField => {
    const input:any = inputField.querySelector('input[type="text"]');
    const error = inputField.querySelector('.form__error');
    if (!input || !error) return;
    input.addEventListener("keyup", () => {
      //@ts-ignore
      if (input.value == "") {
        error.classList.add("show");
        error.innerHTML = emptyMsg
      }
      else {
        error.classList.remove("show");
      }
    })
  })
}

export default orderName
